import { Component, OnInit, ElementRef } from '@angular/core';
import { DataDBService } from '../servicios/data-db.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PeticionesService } from '../servicios/httpservice';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-partner-detalle-descuentos',
  templateUrl: './partner-detalle-descuentos.component.html',
  styleUrls: ['./partner-detalle-descuentos.component.css']
})

export class PartnerDetalleDescuentosComponent implements OnInit {
  public arrayAccesos:any=[];
  public DatosUsuario:any;
  public tagName:any;
  public strConexion:string ='';
  public arrayDescuentos:any = [];
  public strBuscarArt:string = ""
  public strCategoria:string=""; 
  public arraySubCategoria: any=[];
  public arrayArticulos: any=[];
  public arraySubcategorias: any=[];
  public spiner: boolean = false;
  public hovered: boolean = false;
  public strBuscar: string = "";
  public inputPrecioMin:number = 0;
  public inputPrecioMax:number =0;
  public precioMin: number = 0; // Precio mínimo inicial
  public precioMax: number = 0; // Precio máximo inicial
  public precioMaximo: number = 33704; 
  public articulosFiltrados: any = [];
  private secretKey: string = 'ec0d3li2o2e';
  precioMid:number = 0
  public objAplicaLinea:any;
  private strLinea:string = "";
  public arrayOpciones :any = []
  public strOpcion_Selected: string = ""
  public boolSpinner:boolean= false;
  public objOpcion :any;
  constructor(public localSt: LocalStorageService,private indexedDBService: DataDBService,private _httpService: PeticionesService, private router: Router, elem: ElementRef) {
    this.tagName = elem.nativeElement.tagName.toLowerCase();


    let arrayDatos = []
    arrayDatos = JSON.parse(localStorage.getItem('ngx-webstorage|arrayaccesos'))
    if(arrayDatos && arrayDatos.length > 0){


    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
      this.DatosUsuario = this.arrayAccesos[0]
      if (this.arrayAccesos.length > 0) {
        this.DatosUsuario = this.arrayAccesos[0]
        this._httpService.setMostrarMenu(true);
        this.strConexion = this.localSt.retrieve('strConexion');
        this.objAplicaLinea= sessionStorage.getItem('datosCompletos');
        if (this.objAplicaLinea) {
          this.objAplicaLinea = JSON.parse(this.objAplicaLinea);
       
          if(this.objAplicaLinea.strAplicaLinea && this.objAplicaLinea.strAplicaLinea != ""&& this.objAplicaLinea.strAplicaLinea != undefined&& this.objAplicaLinea.strAplicaLinea != null){
            this.strLinea = this.objAplicaLinea.strAplicaLinea
            this.fnGetArticulos();
          }else{
            this.strLinea = this.objAplicaLinea.strArticulo
            this.fnGetArticulosMin()
          }
        }
      } else {
        this.router.navigate(['/login']);
      }
    });

  }else{
    this.strConexion = 'COMERCIAL'
  
        this.objAplicaLinea= sessionStorage.getItem('datosCompletos');
        if (this.objAplicaLinea) {
          this.objAplicaLinea = JSON.parse(this.objAplicaLinea);
          
          if(this.objAplicaLinea.strAplicaLinea && this.objAplicaLinea.strAplicaLinea != ""&& this.objAplicaLinea.strAplicaLinea != undefined&& this.objAplicaLinea.strAplicaLinea != null){
            this.strLinea = this.objAplicaLinea.strAplicaLinea
            this.fnGetArticulos();
          }else{
            this.strLinea = this.objAplicaLinea.strArticulo
            this.fnGetArticulosMin()
          }
        }
  }
   }

  ngOnInit(): void {
   

    
  }


  fnGetArticulos() {
    this.boolSpinner = true
    this.arraySubcategorias=[];
    this.arrayArticulos = [];
    let articulo = {
      strAccion: "getPromoLineas",
      strArticuloBusqueda:this.strLinea,
      strConexion: "COMERCIAL"
    };
 
    this._httpService.mostrarCotizaciones(articulo, 'sp_ModVentas_Cotizador').subscribe(
      result => {
     
        this.arrayArticulos = result
        this.arrayArticulos.forEach(item => {
          let descuento = 100 - ((item.dblPrecioOferta / item.dblPrecioLista) * 100);
          let decimal = descuento - Math.floor(descuento);
          let resultado = decimal > 0.001 ? Math.ceil(descuento) : Math.floor(descuento);
          item.oferta = resultado;
          item.hovered=false;
        });
        let arrayPrecios = this.arrayArticulos
        .filter(producto => typeof producto.dblPrecioLista === 'number' && !isNaN(producto.dblPrecioLista))
        .map(producto => producto.dblPrecioLista);
        this.inputPrecioMin = Math.min(...arrayPrecios);
        this.inputPrecioMax = Math.max(...arrayPrecios);
        this.precioMax = this.inputPrecioMax;
        this.precioMid = this.precioMax / 2 
        this.boolSpinner = false
      },error=>{ 
        this.boolSpinner = false
      });
  }
  
  decreaseQty(item: any) {
    item.dblCantidadMinima = Math.max(0.1, (item.dblCantidadMinima || 1) - 1);
  }
  
  increaseQty(item: any) {
    item.dblCantidadMinima = (item.dblCantidadMinima || 1) + 1;
  }
  
  agregarAlCarrito(item: any) {

    if (this.arrayAccesos.length > 0) {

    localStorage.setItem('strArticulo_Seleccionado_Cotizador', JSON.stringify(item));
    this.localSt.clear('strArticulo_Seleccionado_Comodato' );
    this.router.navigate(['/detalle_articulo']);}else{
      this.router.navigate(['/login']);
    }

  }
  onImgError(event: any) {
    event.target.src = 'assets/detoportunidad/noDisponible.jpg';
  }

  fnGetArticulosMin() {
    this.boolSpinner = true
    this.arraySubcategorias=[];
    this.arrayArticulos = [];
    let articulo = {
      strAccion: "getPromoMinArts",
      strArticuloBusqueda:this.strLinea,
      strConexion: "COMERCIAL"
    };

    this._httpService.mostrarCotizaciones(articulo, 'sp_ModVentas_Cotizador').subscribe(
      result => {

        this.arrayArticulos = result
        this.arrayArticulos.forEach(item => {
          let descuento = 100 - ((item.dblPrecioOferta / item.dblPrecioLista) * 100);
          let decimal = descuento - Math.floor(descuento);
          let resultado = decimal > 0.001 ? Math.ceil(descuento) : Math.floor(descuento);
          item.oferta = resultado;
          item.hovered=false;
        });
        let arrayPrecios = this.arrayArticulos
        .filter(producto => typeof producto.dblPrecioLista === 'number' && !isNaN(producto.dblPrecioLista))
        .map(producto => producto.dblPrecioLista);
        this.inputPrecioMin = Math.min(...arrayPrecios);
        this.inputPrecioMax = Math.max(...arrayPrecios);
        this.precioMax = this.inputPrecioMax;
        this.precioMid = this.precioMax / 2 
        this.boolSpinner = false
      },error=>{ 
        this.boolSpinner = false
      });
  }
  


}
